import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { Edit, Upload, Delete } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Product } from '../../../../types';

interface ProductActionMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  selectedProduct: Product | null;
  basePath: string;
  onDeleteClick: () => void;
}

const ProductActionMenu: React.FC<ProductActionMenuProps> = ({
  anchorEl,
  onClose,
  selectedProduct,
  basePath,
  onDeleteClick,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      PaperProps={{
        sx: {
          bgcolor: 'background.paper',
          borderRadius: '8px',
        },
      }}
    >
      <MenuItem onClick={() => {
        if (selectedProduct) navigate(`${basePath}/${selectedProduct.id}/edit`);
        onClose();
      }}>
        <Edit sx={{ mr: 1, fontSize: 18 }} /> {t('admin.editProductAction')}
      </MenuItem>
      <MenuItem onClick={() => {
        if (selectedProduct) navigate(`${basePath}/${selectedProduct.id}/duplicate`);
        onClose();
      }}>
        <Upload sx={{ mr: 1, fontSize: 18 }} /> {t('admin.duplicate')}
      </MenuItem>
      <MenuItem onClick={onDeleteClick} sx={{ color: '#fe2a5f' }}>
        <Delete sx={{ mr: 1, fontSize: 18 }} /> {t('admin.deleteAction')}
      </MenuItem>
    </Menu>
  );
};

export default ProductActionMenu;